import React from 'react';
import { RouteObject } from 'react-router-dom';
import { InAppNotificationListView } from './views/InAppNotificationListView';

export const inAppNotificationRoutes: RouteObject[] = [
    {
        path: '/notifications',
        children: [
            {
                index: true,
                element: <InAppNotificationListView />,
            },
        ],
    },
];
